import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setDepositFormAction } from "../../redux/rootReducer";
import Payment from "../Payment/Payment";
import { DEPOSIT_FORM_INITIAL } from "../../redux/initialStateConstant";
import { updateDepositSagaAction } from "../../redux/sagaActions";

const DepositForm = () => {
    const dispatch = useDispatch();
    const deposit_form = useSelector(state => state.deposit_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(setDepositFormAction(DEPOSIT_FORM_INITIAL)) }/>
                        <div className="form__title">Новый депозит</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Сумма</div>
                        <input type="text" className="input"
                            value={ deposit_form.sum }
                            onInput={ event => dispatch(setDepositFormAction({ ...deposit_form, sum: event.target.value })) }
                        />
                    </div>
                    {
                        !deposit_form.id &&
                        <Payment
                            payment={ deposit_form.payment }
                            totalSum={ deposit_form.sum }
                            discountValue={ deposit_form.discount }
                            handler={ ({ payment, discount }) => dispatch(setDepositFormAction({
                                ...deposit_form,
                                payment,
                                discount
                            })) }
                        />
                    }
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                let formattedPayments = [];
                                // Фильтруем и форматируем платежи
                                deposit_form.payment.forEach(el => {
                                    if (el.cost) {
                                        formattedPayments.push({ cost: el.cost, payment_method: el.payment_method.id });
                                    }
                                });

                                dispatch(updateDepositSagaAction({
                                    id: deposit_form.id,
                                    sum: deposit_form.sum,
                                    payment: JSON.stringify(formattedPayments),
                                    discount: deposit_form.discount.id
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DepositForm;